import React from "react";

const TableShimmer = ({ columns = 4, rows = 5 }) => {
  return (
    <div className="w-full min-h-[40vh] space-y-10 mt-10">
      {/* Header shimmer */}
      <div className="flex items-center gap-3">
        {Array.from({ length: columns }).map((_, index) => (
          <div
            key={index}
            className="h-6 flex-1 bg-gray-200  rounded-md animate-pulse"
          />
        ))}
      </div>

      {/* Rows shimmer */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex items-center gap-3">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className="h-5 flex-1 bg-gray-100 rounded-md animate-pulse"
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableShimmer;
